import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

import styled from 'styled-components';
import TableCont from './Table';
import { CustomText } from 'common/Reusables';

const data = [
  {
    name: 'How to make deductions and add allowances',
    url: 'https://blog.bizedgeapp.com/how-to-make-deductions-and-add-allowances-on-bizedge-payroll',
    subText: 'Understand the  ways for making accounting interesting'
  },
  {
    name: 'How to prepare payroll using bizedge',
    url: 'https://blog.bizedgeapp.com/how-to-prepare-payroll-seamlessly',
    subText: 'Understand the  ways for making accounting interesting'
  },
  {
    name: 'How to set up time and attendance',
    url: 'https://blog.bizedgeapp.com/how-to-set-up-time-and-attendance',
    subText: 'Understand the  ways for making accounting interesting'
  },
  {
    name: 'Managing your Assets on BizEdge',
    url: 'https://blog.bizedgeapp.com/managing-assets-on-the-bizedgeapp',
    subText: 'Understand the  ways for making accounting interesting'
  },
  {
    name: 'How To Send MyEdge Invite',
    url: 'https://blog.bizedgeapp.com/how-to-send-myedge-invite',
    subText: 'Understand the  ways for making accounting interesting'
  },
  {
    name: 'Setting up Time-off Policy',
    url: 'https://blog.bizedgeapp.com/setting-up-time-off-policy',
    subText: 'Understand the  ways for making accounting interesting'
  }
];

const howTos = [
  {
    category: 'People web',
    items: [
      {
        id: 1,
        name: 'How To Request And Accept Profile Update On BizEdge',
        subText:
          'The MyEdge app allows employees to request profile updates, which HR personnel must approve.',
        url: 'https://bizedgeapp.com/blog/how-to-request-and-accept-profile-update-on-bizedge'
      },
      {
        id: 2,
        name: 'Setting Up Time-Off Policy',
        subText:
          'The time-off section allows you to create and assign time off to an employee added to BizEdge.',
        url: 'https://bizedgeapp.com/blog/setting-up-time-off-policy'
      },
      {
        id: 3,
        name: 'User Access Levels On BizEdge',
        subText:
          'The BizEdge app includes a feature allowing admins to grant employees varying levels of access to BizEdge app.',
        url: 'bizedgeapp.com/blog/user-access-levels-on-bizedge'
      },
      {
        id: 4,
        name: 'Setting Up MyTeam App For Line Managers',
        subText:
          'The MyTeam App simplifies basic line manager responsibilities, enabling them to approve time off requests, view team members, and track essential team activities.',
        url: 'https://bizedgeapp.com/blog/setting-up-myteam-app-for-line-managers'
      },
      {
        id: 5,
        name: 'How To Send Myedge Invite To Employees On BizEdge People Web',
        subText:
          'Learn how to efficiently send MyEdge invites to employees using the BizEdge People app.',
        url: 'https://bizedgeapp.com/blog/how-to-send-myedge-invite'
      },
      {
        id: 6,
        name: 'How To Onboard Employees On Bizedge On Web',
        subText:
          'Ensure seamless employee onboarding with BizEdge facilitating smooth information sharing, document requests, and preparation for their first day.',
        url: 'https://bizedgeapp.com/blog/how-to-onboard-new-employees-on-bizedge'
      },
      {
        id: 7,
        name: 'How To View Time Off Balances And Manage Leave Requests',
        subText:
          'Learn how to approve or decline time off leave requests of your employees on BizEdge Web',
        url: 'https://bizedgeapp.com/blog/how-to-view-time-off-balance-and-manage-leave-requests'
      },
      {
        id: 8,
        name: 'How To Add And Edit Employee Information On BizEdge',
        subText:
          'Manage employee profiles effortlessly using the BizEdge people app to add and edit their information.',
        url: 'https://bizedgeapp.com/blog/how-to-update-employee-job-title-and-compensation'
      },
      {
        id: 9,
        name: 'Managing Benefits On BizEdge People App',
        subText:
          'Provide benefits such as health, pension, and more for your organization or allocate them to existing employees.',
        url: 'https://bizedgeapp.com/blog/managing-benefits-on-bizedge-people-module'
      }
    ]
  },
  {
    category: 'Payroll Web',
    items: [
      {
        id: 1,
        name: 'How To Prepare Payroll Using Bizedge Web',
        subText:
          'Effortlessly pay your employees with the BizEdge Payroll app, ensuring timely and accurate employee compensation.',
        url: 'https://bizedgeapp.com/blog/how-to-prepare-payroll-seamlessly'
      },
      {
        id: 2,
        name: 'How To Make Deductions And Add Allowances On BizEdge Payroll',
        subText:
          'Effortlessly manage allowances and deductions with the BizEdge Payroll app, simplifying compensation processes.',
        url: 'https://bizedgeapp.com/blog/how-to-make-deductions-and-add-allowances-on-bizedge-payroll'
      }
    ]
  },
  {
    category: 'Time and Attendance web',
    items: [
      {
        id: 1,
        name: 'How To Set Up Time And Attendance',
        subText:
          "Learn how to efficiently manage employee time and attendance using BizEdge's intuitive platform.",
        url: 'https://bizedgeapp.com/blog/how-to-set-up-time-and-attendance'
      }
    ]
  },
  {
    category: 'Assets Web',
    items: [
      {
        id: 1,
        name: 'Managing Your Assets/vehicle On BizEdge',
        subText:
          "Gain a comprehensive overview of your organization's assets and vehicles effortlessly, including their status, recent additions, and assignments",
        url: 'https://bizedgeapp.com/blog/managing-your-vehicles-on-the-bizedgeapp'
      }
    ]
  },
  {
    category: 'Performance Web',
    items: [
      {
        id: 1,
        name: 'How To Create An Appraisal Cycle On BizEdge Performance App',
        subText:
          'This guide shows you how to create an appraisal cycle on the BizEdge Performance App, including setting its duration and defining review forms.',
        url: 'https://bizedgeapp.com/blog/how-to-create-an-appraisal-cycle'
      },
      {
        id: 2,
        name: 'How To Set Up A Performance Cycle From Competency To Preference',
        subText:
          'Improve employee performance by setting up a performance cycle from competency to preference.',
        url: 'https://bizedgeapp.com/blog/how-to-set-up-a-performance-life-cycle-from-competency-to-preference'
      },
      {
        id: 3,
        name: 'How To Set Up Appraisal Team Goals As A Line Manager',
        subText: 'Set up appraisal team goals as a line manager on MyTeam App.',
        url: 'https://bizedgeapp.com/blog/how-to-set-up-appraisal-team-goals-as-a-line-manager'
      }
    ]
  },
  {
    category: 'Referencing Web',
    items: [
      {
        id: 1,
        name: 'How To Get Started With BizEdge Referencing App',
        subText:
          'The BizEdge Referencing app simplifies and automates the reference checking process for employers, making it user-friendly and efficient',
        url: 'https://bizedgeapp.com/blog/how-to-get-started-with-bizedge-referencing-app'
      }
    ]
  }
];

const EssentialTopics = ({ stage, setStage }) => {
  const [url, setUrl] = useState('');

  return (
    <EssentialTopics.Wrapper>
      {stage === 0 && (
        <>
          {/* <TextField
            style={{
              width: '100%'
            }}
            placeholder='Search for topics'
            color='secondary'
            variant='outlined'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <IconButton>
                    <SearchIcon fontSize='small' />
                  </IconButton>
                </InputAdornment>
              )
            }}
          /> */}

          {howTos.map(({ category, items }) => (
            <div key={category} style={{ marginTop: '32px' }}>
              <CustomText fontWeight={600} fontSize={'18px'} color='#171717'>
                {category}
              </CustomText>
              {items?.map((item) => (
                <TableCont
                  key={item.name}
                  name={item.name}
                  subText={item.subText}
                  // handler={() => {
                  //   setStage(item.name);
                  //   setUrl(item.url);
                  // }}
                  handler={() => window.open(item.url, '_blank')}
                  bgColor='white'
                />
              ))}
            </div>
          ))}
        </>
      )}
      {stage === 1 && (
        <>
          <div className='single-app' onClick={() => setStage(0)}>
            <IconButton style={{ marginLeft: -10 }}>
              <KeyboardBackspaceIcon />
            </IconButton>
            {/* <div className='h1'>{stage}</div> */}
          </div>

          <iframe title={stage} src={url} frameborder='0'></iframe>
        </>
      )}
    </EssentialTopics.Wrapper>
  );
};

export default EssentialTopics;

EssentialTopics.Wrapper = styled.div`
  margin-top: 20px;
  .h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    color: #545454;
  }
  .texts {
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    color: #545454;
  }
  iframe {
    width: 100%;
    height: 100vh;
    display: block;
  }
`;
